export const triggerDownload = (fileData, filename = "download.bin") => {
  const blob =
    fileData instanceof Blob
      ? fileData
      : new Blob([fileData], { type: "application/octet-stream" });

  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};